import { render, staticRenderFns } from "./ProjectList_Curly.vue?vue&type=template&id=3049c3e7&scoped=true"
import script from "./ProjectList_Curly.vue?vue&type=script&lang=js"
export * from "./ProjectList_Curly.vue?vue&type=script&lang=js"
import style0 from "./ProjectList_Curly.vue?vue&type=style&index=0&id=3049c3e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049c3e7",
  null
  
)

export default component.exports